import React, { useState } from 'react'
import { PageProps } from 'gatsby'

import Providers, { Config } from 'components/layout/Providers'

import { applyFilters } from '../../exploreComponents/FilterBar/filterOperations'
import Table from './pageComponents/Table'
import useExploreTableResources from 'dataHooks/useExploreTableResources'
import { ExploreState } from '../../types'
import ExploreWithFilters from '../../exploreComponents/ExploreWithFilters'

const ExplorePage = ({ pageContext }: PageProps): JSX.Element => {
  // cast pageContext to correct type
  const config = pageContext as Config

  const resources = useExploreTableResources()
  const [exploreState, setExploreState] = useState<ExploreState>({})

  // let resources: ResourceGroup[] = groupedResources.map(group => ({
  //   ...group,
  //   totalCount: group.nodes.length,
  // }))

  const resourceNodes = applyFilters(resources.nodes, exploreState.filters)

  // resources.map(group =>
  //   group.nodes.sort(node => node.data.Authoring_organization)
  // )
  return (
    <Providers config={config}>
      <ExploreWithFilters {...{ exploreState, setExploreState }}>
        <Table resources={resourceNodes} />
      </ExploreWithFilters>
    </Providers>
  )
}

export default ExplorePage
